import { render, staticRenderFns } from "./VisorPedidoItem.vue?vue&type=template&id=34c07b84&scoped=true"
import script from "./VisorPedidoItem.vue?vue&type=script&lang=js"
export * from "./VisorPedidoItem.vue?vue&type=script&lang=js"
import style0 from "./VisorPedidoItem.vue?vue&type=style&index=0&id=34c07b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c07b84",
  null
  
)

export default component.exports